/**
 * Where to go back to after signing in (LH-1508).
 *
 * The server carries the path through the OAuth state (`/auth/login?redirect=`) and
 * checks it again with the same rule (`@shared/return-path`); this side decides
 * which path to ask for.
 */

import { isSignInPath, safeReturnPath } from '@shared/return-path.js';

export { safeReturnPath };

/**
 * The path sign-in should return to, from the address shown now. The sign-in page
 * itself carries it as `?redirect=`; any other page is its own destination (the
 * auth guard shows the sign-in page in place, at the address the person opened).
 */
export function returnPathFor(pathname: string, search: string, hash = ''): string {
  const params = new URLSearchParams(search);
  if (isSignInPath(pathname)) return safeReturnPath(params.get('redirect'));
  params.delete('_auth');
  params.delete('error');
  const query = params.toString();
  return safeReturnPath(`${pathname}${query ? `?${query}` : ''}${hash}`);
}
